import { DTOCreateDocumentationPageInputV2, DTODeleteDocumentationPageInputV2, DTODocumentationPageApprovalStateChangeInput, DTODuplicateDocumentationPageInputV2, DTOMoveDocumentationPageInputV2, DTORestoreDocumentationGroupInput, DTORestoreDocumentationPageInput, DTOUpdateDocumentationPageDocumentInputV2, DTOUpdateDocumentationPageInputV2, } from "./page-v2";
import { z } from "zod";
//
// Read
//
const SuccessPayload = z.object({
    success: z.literal(true),
});
export const DTODocumentationPageCreateActionOutputV2 = z.object({
    type: z.literal("DocumentationPageCreate"),
    output: SuccessPayload,
});
export const DTODocumentationPageUpdateActionOutputV2 = z.object({
    type: z.literal("DocumentationPageUpdate"),
    output: SuccessPayload,
});
export const DTODocumentationPageUpdateDocumentActionOutputV2 = z.object({
    type: z.literal("DocumentationPageUpdateDocument"),
    output: SuccessPayload,
});
export const DTODocumentationPageMoveActionOutputV2 = z.object({
    type: z.literal("DocumentationPageMove"),
    output: SuccessPayload,
});
export const DTODocumentationPageDuplicateActionOutputV2 = z.object({
    type: z.literal("DocumentationPageDuplicate"),
    output: SuccessPayload,
});
export const DTODocumentationPageDeleteActionOutputV2 = z.object({
    type: z.literal("DocumentationPageDelete"),
    output: SuccessPayload,
});
export const DTODocumentationPageRestoreActionOutput = z.object({
    type: z.literal("DocumentationPageRestore"),
    output: SuccessPayload,
});
export const DTODocumentationGroupRestoreActionOutput = z.object({
    type: z.literal("DocumentationGroupRestore"),
    output: SuccessPayload,
});
export const DTODocumentationPageApprovalStateChangeActionOutput = z.object({
    type: z.literal("DocumentationPageApprovalStateChange"),
    output: SuccessPayload,
});
// Write
//
export const DTODocumentationPageCreateActionInputV2 = z.object({
    type: z.literal("DocumentationPageCreate"),
    input: DTOCreateDocumentationPageInputV2,
});
export const DTODocumentationPageUpdateActionInputV2 = z.object({
    type: z.literal("DocumentationPageUpdate"),
    input: DTOUpdateDocumentationPageInputV2,
});
export const DTODocumentationPageUpdateDocumentActionInputV2 = z.object({
    type: z.literal("DocumentationPageUpdateDocument"),
    input: DTOUpdateDocumentationPageDocumentInputV2,
});
export const DTODocumentationPageMoveActionInputV2 = z.object({
    type: z.literal("DocumentationPageMove"),
    input: DTOMoveDocumentationPageInputV2,
});
export const DTODocumentationPageDuplicateActionInputV2 = z.object({
    type: z.literal("DocumentationPageDuplicate"),
    input: DTODuplicateDocumentationPageInputV2,
});
export const DTODocumentationPageDeleteActionInputV2 = z.object({
    type: z.literal("DocumentationPageDelete"),
    input: DTODeleteDocumentationPageInputV2,
});
export const DTODocumentationPageRestoreActionInput = z.object({
    type: z.literal("DocumentationPageRestore"),
    input: DTORestoreDocumentationPageInput,
});
export const DTODocumentationGroupRestoreActionInput = z.object({
    type: z.literal("DocumentationGroupRestore"),
    input: DTORestoreDocumentationGroupInput,
});
export const DTODocumentationPageApprovalStateChangeActionInput = z.object({
    type: z.literal("DocumentationPageApprovalStateChange"),
    input: DTODocumentationPageApprovalStateChangeInput,
});
